export const KeyCodeMapping: Record<string, string> = {};
